<template>
  <div v-if="stats.length" class="statsRowContainer">
    <component v-bind:is="titleHeading" class="text-center">
      {{ title }}
    </component>
    <div class="container statsList">
      <div v-for="{ label, value } in stats" :key="label" class="stat">
        <div class="value">
          {{ value }}
        </div>
        <div class="label gradient-secondary text-center">
          {{ label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsRow',
  props: {
    title: {
      type: String,
      required: false,
      default: 'The Original. We Got This.'
    },
    largeTitle: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      stats: jsConfig.stats || []
    };
  },
  computed: {
    titleHeading() {
      return this.largeTitle ? 'h3' : 'h4';
    }
  }
};
</script>

<style lang="scss">
  @import '@sass/vue-imports.scss';

  .statsRowContainer {
    background-color: $dark-gray;
    color: #FFF;
    letter-spacing: 0.02em;
    width: 100%;

    h3, h4 {
      color: #fff;
      padding: 70px 0;
      margin: 0;
    }

    .statsList {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      @include media-breakpoint-down(sm) {
        flex-direction: column;
        align-items: center;
      }

      .stat {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 20px 70px;
        .value {
          color: $primary;
          font-weight: 900;
          font-size: 31px;
          line-height: 33px;
        }
        .label {
          color: #FFF;
          text-transform: uppercase;
          font-weight: 700;
          font-size: 16px;
          max-width: 170px;
        }
      }

    }
    @include media-breakpoint-down(sm) {
      h3, h4 {
        padding: 24px 0 0;
      }
      .statsList {
        flex-direction: column !important;

        .stat {
          border-bottom: 1px solid $corduroy;
          margin: 0;
          padding: 24px 0;
          text-align: center;
        }
      }
    }
  }
</style>
